
<!-- 我们的保障 -->
<template>
  <div class="Ourprotection">
  <div class="newlist">
    <!-- <div class="newlist_item wow slideInLeft" data-wow-duration="1s" v-for="(item, index) in imgData" :key="index" >
        <img :width="281" :height="200" :src="item.srcUrl" alt="">
        <div class="newlist_name">{{ item.name }}</div>
                        <div class="newlist_text">{{ item.text }}</div>
                      </div> -->
      <div class="newlist_item wow bounceInLeft" data-wow-duration="2s">
        <img width="237" height="168" :src="imgData[0].srcUrl" alt="">
        <div class="newlist_name">{{ imgData[0].name }}</div>
        <div class="newlist_text">{{ imgData[0].text }}</div>
      </div>
      <div class="newlist_item wow bounceInLeft" data-wow-duration="2s">
        <img width="237" height="168" :src="imgData[1].srcUrl" alt="">
        <div class="newlist_name">{{ imgData[1].name }}</div>
        <div class="newlist_text">{{ imgData[1].text }}</div>
      </div>
      <div class="newlist_item wow bounceInRight" data-wow-duration="2s">
        <img width="237" height="168" :src="imgData[2].srcUrl" alt="">
        <div class="newlist_name">{{ imgData[2].name }}</div>
        <div class="newlist_text">{{ imgData[2].text }}</div>
      </div>
      <div class="newlist_item wow bounceInRight" data-wow-duration="2s">
        <img width="237" height="168" :src="imgData[3].srcUrl" alt="">
        <div class="newlist_name">{{ imgData[3].name }}</div>
        <div class="newlist_text">{{ imgData[3].text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { showNumber, packageListHomepage } from "@/api/projectSquare/xmgc";
export default {
  name: 'Ourprotection',
  data() {
    return {
      imgData: [
        { id: 0, srcUrl: require('../../assets/image/indexqiye/4-1.png'), name: '安全保障', text: '资格认证、用户准入、信用评价，真实可靠科学严格的权限管理及灾备系统签署保密协议，保障数据与知识版权' },
        { id: 1, srcUrl: require('../../assets/image/indexqiye/4-2.png'), name: '交易保障', text: '银行专用资金存管结算账户线上交易，平台全程监管电子协议保障交易合规合法' },
        { id: 2, srcUrl: require('../../assets/image/indexqiye/4-3.png'), name: '交付保障', text: '平台认证工程师超过百万级,编程自动化技术提升项目进度，完备的质量管控体系，多方位项目管控' },
        { id: 3, srcUrl: require('../../assets/image/indexqiye/4-4.png'), name: '标准保障', text: '源码生成统一规范，符合行业标准多端统一框架，智能规范校验标准接口，支持数据跨系统交互' },
      ]


    };
  },
watch:{
  $route(to,form){
    this.nextTick(()=>{
      const wow=new this.$wow.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        live: false
      })
      wow.init()
    })
  }
},
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        live: false
      }).init()
    });

  },
  methods: {

  },
};
</script>

<style scoped>
.Ourprotection {
  padding-bottom: 120px;
}

.newlist {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}

.newlist_item {
  width: 276px;
  height: 442px;
  background: #F4FAFF;
  box-shadow: 0px 4px 8px 0px rgba(0, 38, 60, 0.1);
  border-radius: 4px 4px 4px 4px;
  padding: 20px 0;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  transition: 1s;
}

.newlist_item:hover {
  transform: scale(1.08);
  z-index: 3;
  box-shadow: 0px 2px 20px 0px #999999;
}

.newlist_name {
  width: max-content;
  font-size: 32px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  line-height: 38px;
  text-align: left;
  padding: 12px 21px 16px;
}

.newlist_text {
  padding: 0 21px;
  font-size: 18px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/Ourprotection.vue